module.exports = __webpack_public_path__ + "img/744.5e922c92.jpg";